"use strict";

var $ = require("jquery");
import { dropdownToggle } from './_dropdownToggle.js';

$(document).ready(function () {

    const button = $('.nav-categories-btn');

    button.on('click', function () {
        dropdownToggle('nav-categories');
        //$('.header-top').toggle('show');
    });
});